import React from 'react';
import { useTranslation } from 'react-i18next';
import { observer, useLocalStore } from 'mobx-react';
import SVG from 'react-inlinesvg';
import { Tooltip } from '@patternfly/react-core';
import { withErrorBoundary } from 'react-error-boundary';
import { handleError } from 'services/ErrorService';
import GenericViewError from 'components/Error/GenericViewError';
import CSVIcon from 'img/icons/csv-download.svg';
import useMobxStores from 'hooks/useMobxStores';
import TopSummary from './TopSummary';
import MainSection from './MainSection';
import Store from './store';
import './styles.scss';

const Dashboard = () => {
  const { userStore } = useMobxStores();
  const { t } = useTranslation();
  const store = useLocalStore(() => new Store(userStore));

  const downloadCSV = () => {
    store.fetchConsolidatedReportCSV();
  };

  const handleCsvKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      downloadCSV();
    }
  };

  return (
    <div className="dashboard-wrapper">
      <div className="download-options-wrapper">
        <Tooltip
          content={t('Download consolidated CSV')}
          entryDelay={0}
          exitDelay={0}
        >
          <div className="svg-holder pull-right">
            <span
              onClick={downloadCSV}
              onKeyDown={handleCsvKeyDown}
              role="button"
              tabIndex={0}
              data-analytics-id="download-dboard-lp"
              aria-label={t('Download consolidated CSV')}
            >
              <SVG src={CSVIcon} />
            </span>
          </div>
        </Tooltip>
      </div>
      <TopSummary />
      <MainSection />
    </div>
  );
};

export default withErrorBoundary(
  observer(Dashboard),
  GenericViewError,
  handleError,
);
